if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form.id) this.form.id = `product-form-${this.dataset.sectionId || 'main'}`;
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.isMainProductForm = this.closest('product-info[id^="MainProduct-"]') !== null;
        this.stickySubmitButton = this.isMainProductForm
          ? document.querySelector('#ProductSubmitButton-sticky')
          : null;
        this.stickySubmitButtonText = this.stickySubmitButton?.querySelector('span');
        this.onStickySubmitClick = this.onStickySubmitClick.bind(this);
        this.stickySubmitButton?.addEventListener('click', this.onStickySubmitClick);

        this.notifyMeButton = document.querySelector('button#BIS_trigger');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
          this.stickySubmitButton?.setAttribute('aria-haspopup', 'dialog');
        }

        // this.hideErrors = this.dataset.hideErrors === 'true';
      }

      disconnectedCallback() {
        this.stickySubmitButton?.removeEventListener('click', this.onStickySubmitClick);
      }

      onStickySubmitClick(event) {
        event.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (this.submitButton.hasAttribute('disabled')) return;
        this.submitButton.click();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButtons.forEach((button) => {
          button.setAttribute('aria-disabled', true);
          button.classList.add('loading');
          button.querySelector('.loading__spinner')?.classList.remove('hidden');
        });

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            // Bugsnag.notify(e);
          })
          .finally(() => {
            this.submitButtons.forEach((button) => {
              button.classList.remove('loading');
            });
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) {
              this.submitButtons.forEach((button) => {
                button.removeAttribute('aria-disabled');
              });
            }
            this.submitButtons.forEach((button) => {
              button.querySelector('.loading__spinner')?.classList.add('hidden');
            });
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          const isAvailability = /availability|disponib|verfügbarkeit|在庫/i.test(errorMessage);
          let message = errorMessage.replace(/\s+$/, '');
          if (isAvailability) {
            const quantity = parseInt(message.match(/\d+/)?.[0] || '1', 10);
            const template =
              quantity === 1 ? window.cartStrings?.availabilityErrorOne : window.cartStrings?.availabilityErrorOther;
            if (template) message = template.replace('[quantity]', quantity);
          }
          const note = window.cartStrings?.notReserved;
          this.errorMessage.textContent =
            isAvailability && note
              ? `${/[.!?]$/.test(message) ? message : `${message}.`} ${note}`
              : message;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButtons.forEach((button) => {
            button.setAttribute('disabled', 'disabled');
          });
          if (text) this.submitButtonText.textContent = text;
          if (text && this.stickySubmitButtonText) this.stickySubmitButtonText.textContent = text;
          this.notifyMeButton?.classList.remove('hidden');
        } else {
          this.submitButtons.forEach((button) => {
            button.removeAttribute('disabled');
          });
          // this.submitButtonText.textContent = window.variantStrings.addToCart;
          this.submitButtonText.textContent = text;
          if (this.stickySubmitButtonText) this.stickySubmitButtonText.textContent = text;
          this.notifyMeButton?.classList.add('hidden');
        }
      }

      get submitButtons() {
        return [this.submitButton, this.stickySubmitButton].filter(Boolean);
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
